import { h } from 'preact'
import InputGroup from '../../ui-components/InputGroup'
import UserAvatar from '../../User/UserAvatar'
import Icon from '../../assets'

const FilterOption = ({ item, data, onFilterOptionSelection } : { item: any, data: any, onFilterOptionSelection: (payload: string[]) => void }) => <InputGroup
  inline
  key={item.id}
  value={item.value}
  title={<div>
    {typeof item.avatar !== 'undefined' && <UserAvatar disableLink disablePopup user={item} />}
    {item.icon && <Icon icon={item.icon} />}
    {item.name}
  </div>}
  type='checkbox'
  formGroupClasses='overview__filters-box-filter'
  checked={data.some((value: string) => String(value) === String(item.value))}
  onChangeCheckbox={(e) => {
    const value = e.target.value
    const checked = e.target.checked

    const payload = checked
      ? [...data, value]
      : data.filter((x: string) => x !== value)

    onFilterOptionSelection(payload)
  }} />

export default FilterOption
